import { Box, CircularProgress, Flex } from "@chakra-ui/react";

import { colors } from "src/colors";

// TODO: remove when use DS
const WholePageProgress = () => {
  return (
    <Flex
      w="100vw"
      h="100vh"
      id="page-progress"
      position="fixed"
      zIndex={1000}
      left={0}
      top={0}
      justifyContent="center"
      alignItems="center"
    >
      <Box
        position="absolute"
        backgroundColor={colors.white.default}
        opacity={0.6}
        zIndex={1}
        width="100%"
        height="100%"
      />
      <CircularProgress
        isIndeterminate
        color="primary.500"
        position="absolute"
        zIndex={2}
        top="50%"
        left="50%"
        transform="translate(-50%, -50%)"
      />
    </Flex>
  );
};

export default WholePageProgress;
